import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myNumber',
  standalone: true,
})
// cut number decimals without rounding
// useful for displaying balances or calculating money amount
export class NumberPipe implements PipeTransform {
  transform(value: number, decimals: number): string {
    let stringValue = value.toString();
    if (stringValue.includes('e')) {
      return (0).toFixed(decimals); // very small number return as 0
    }
    const x = (stringValue + '.0').split('.');
    stringValue = parseFloat(x[0] + '.' + x[1].substr(0, decimals)).toFixed(decimals);
    return stringValue === 'NaN' ? '' : stringValue;
  }
}
